import { render, staticRenderFns } from "./TwoFA.vue?vue&type=template&id=1ce7c59d&scoped=true"
import script from "./TwoFA.vue?vue&type=script&lang=js"
export * from "./TwoFA.vue?vue&type=script&lang=js"
import style0 from "./TwoFA.vue?vue&type=style&index=0&id=1ce7c59d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce7c59d",
  null
  
)

export default component.exports